import LocationalState, {AnchorPoint, LocationalRoadObject} from "./LocationalState";
import {LocationalActionType} from "./actions";
import {AnyAction} from "redux";
import {DisplayFeature} from "../contract-features-3/domain";

const initialState = new LocationalState();

const LocationalReducers = (state: LocationalState = initialState, action: AnyAction): LocationalState => {

    console.log(LocationalActionType[action.type] || 'INITIALIZING', action);

    const actionType: LocationalActionType = action.type;

    switch (actionType) {
        case LocationalActionType.SET_CURRENT_USER:
            return state.withUser(action.currentUser);
        case LocationalActionType.SET_ROAD_OBJECT_TYPES:
            return state.withRoadObjectTypes(action.roadObjectTypes);
        case LocationalActionType.SET_ROAD_OBJECTS:
            return state.withRoadObjects(action.roadObjects);
        case LocationalActionType.SET_SELECTED_TYPES:
            return state.withSelectedTypes(action.selectedTypes)
                .withSelectedRoadObjects([]);
        case LocationalActionType.SET_SELECTED_ROAD_OBJECTS:
            return state.withSelectedRoadObjects(action.selectedRoadObjects);
        case LocationalActionType.SET_ROAD_REFS:
            return state.withRoadSegments(action.roadSegments);
        case LocationalActionType.SET_SELECTED_ROAD_REF:
            return state.withSelectedRoadSegment(action.selectedRoadSegment);
        case LocationalActionType.SET_LOCATIONAL_IN_LANE_MODAL:
            return state.withShowLaneModal(action.locationalSelectedForLaneModal);
        case LocationalActionType.UPDATE_ROADOBJECTS:
            const actionObjects = action.roadObjects as LocationalRoadObject[];
            let updatedRos = state.roadObjects.splice(0).map(ro => {
                return actionObjects.find(changed => changed.id === ro.id) || ro;
            });
            return state.withRoadObjects(updatedRos);
        case LocationalActionType.ADD_TO_PROGRESS_GOAL:
            return state.withProgressGoal(state.progressGoal + action.progress);
        case LocationalActionType.ADD_TO_PROGRESS:
            let newProgress = state.progress + action.progress;
            if (newProgress === state.progressGoal) {
                return state.withProgress(0).withProgressGoal(0);
            }
            return state.withProgress(newProgress);
        case LocationalActionType.SET_ACTIVE_CONFIDENCE_FILTERS:
            return state.withActiveConfidenceFilters(action.activeConfidenceFilters);
        case LocationalActionType.SET_DISPLAY_SYNCHRONIZED_OBJECTS:
            return state.withDisplaySynchronizedObjects(action.show);
        case LocationalActionType.SET_USE_ANCHORS:
            return state.withUseAnchors(action.useAnchors);
        case LocationalActionType.SET_LISTEN_FOR_ANCHORPOINT:
            return state.withListenForAnchorPoint(action.listenForAnchorPoint);
        case LocationalActionType.SET_ANCHOR_POINT:
            let newState = state.withListenForAnchorPoint(null);
            if (action.anchorPoint === AnchorPoint.start){
                return newState.withStartAnchor(action.latlng)
            } else {
                return newState.withEndAnchor(action.latlng)
            }
        case LocationalActionType.SET_AUTO_LOCALIZE_MODAL_VISIBILITY:
            return state.withShowAutoLocalizeModal(action.showAutoLocalizeModal);
        case LocationalActionType.SET_FEATURE_IN_DETAILS_MODAL:
            return state.withFeatureInDetailsModal(action.detailsModalFeatureId);
        case LocationalActionType.TOGGLE_SKRIV_LOCATIONALS:
            if (state.user) {
                return state.withUser(state.user.withFeatureToggles(action.active));
            } else {
                return state;
            }
        case LocationalActionType.SET_DATACATALOG:
            return state.withDatacatalog(action.datacatalog);
        case LocationalActionType.FETCHING_POINTS_FROM_REFERENCE:
            return state.withFetchingPointsFromReference(action.fetching);
        case LocationalActionType.SET_SELECTED_OVERWRITE_ROAD_CATEGORY:
            return state.withSelectedOverwriteRoadCategory(action.category);
        case LocationalActionType.SET_SELECTED_OVERWRITE_ROAD_USER_GROUP:
            return state.withSelectedOverwriteRoadUserGroup(action.group);
        default:
            return state;
    }
};

export default LocationalReducers;